import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    SimpleChanges
} from '@angular/core';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { HighlightBlockConfiguration } from './models/highlight-block.types';

@Component({
    selector: 'nw-highlight-block',
    imports: [NgOptimizedImage, SanitizeHtmlPipe],
    templateUrl: './highlight-block.component.html',
    styleUrl: './highlight-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HighlightBlockComponent implements OnChanges {
    @Input() config!: HighlightBlockConfiguration.Config | string;

    public configuration!: HighlightBlockConfiguration.Config;

    public ngOnChanges({ config }: SimpleChanges): void {
        if (config?.currentValue) {
            this.configuration =
                typeof this.config === 'string'
                    ? JSON.parse(this.config)
                    : { ...this.config };
        }
    }
}
